import { useAppSelector } from '@/redux/hooks';
import FixedBottomNavigation from '.';
import SkeletonHome from '@/pages/skeletonHome/SkeletonHome';

export default function BottomNavigatorLoader() {
	return <FixedBottomNavigation/>
}
